'use strict';

var _productTile = require('../ProductTile/productTile');

var _productTile2 = _interopRequireDefault(_productTile);

var _productTileMobile = require('../ProductTileMobile/productTileMobile');

var _productTileMobile2 = _interopRequireDefault(_productTileMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = require('lodash');
var React = require('react');
var PropTypes = require('prop-types');

var createReactClass = require('create-react-class');

var LocalizationMixin = require('../../localization/CommonLocalizationMixin');

var ChangeNextRewardComponent = createReactClass({
    displayName: 'ChangeNextRewardComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        rewardOptions: PropTypes.array.isRequired,
        currentTotalPoints: PropTypes.number.isRequired,
        setSelectedReward: PropTypes.func.isRequired,
        selectedRewardId: PropTypes.number,
        isSignUpPage: PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            selectedRewardId: this.props.selectedRewardId
        };
    },

    render: function render() {
        var _this = this;

        var nextRewardTiles = [];

        if (this.props.rewardOptions.length > 0) {
            nextRewardTiles = this.props.rewardOptions.map(function (reward, idx) {

                var pointsNeeded = _this.getLocalizedText('rewards_yours_now');
                if (reward.points > _this.props.currentTotalPoints) {
                    pointsNeeded = reward.points - _this.props.currentTotalPoints + ' ' + (_this.props.isSignUpPage ? _this.getLocalizedText("rewards_points") : _this.getLocalizedText("rewards_points_needed"));
                }

                return React.createElement(
                    'div',
                    { className: 'reward-element', key: 'reward-element-' + idx },
                    React.createElement(
                        'div',
                        { className: 'col-sm-3 hidden-xs desktop-reward' },
                        React.createElement(
                            _productTile2.default,
                            { displayName: reward.name,
                                calories: pointsNeeded,
                                imageUrl: reward.image,
                                onClick: function onClick() {
                                    _this.selectReward(reward);
                                } },
                            reward.rewardId === _this.state.selectedRewardId && React.createElement('div', { className: 'selected' })
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'hidden-lg hidden-md hidden-sm mobile-reward' },
                        React.createElement(_productTileMobile2.default, { displayName: reward.name,
                            calories: pointsNeeded,
                            imageUrl: reward.image,
                            onClick: function onClick() {
                                _this.selectReward(reward);
                            },
                            cntry: _this.props.cntry,
                            lang: _this.props.lang,
                            selectedFlag: reward.rewardId === _this.state.selectedRewardId })
                    )
                );
            });
        }

        return React.createElement(
            'div',
            { className: 'choose-reward-container' },
            React.createElement(
                'div',
                { className: 'row' },
                nextRewardTiles
            ),
            React.createElement(
                'div',
                { className: 'choose-button-wrapper' },
                React.createElement(
                    'button',
                    { type: 'button', disabled: this.state.selectedRewardId <= 0,
                        className: 'btn btn-primary choose-button',
                        onClick: this.setSelectedReward },
                    this.getLocalizedText("rewards_choose").toUpperCase()
                )
            )
        );
    },

    setSelectedReward: function setSelectedReward() {
        var _this2 = this;

        var selectedReward = _.find(this.props.rewardOptions, function (rewardOption) {
            return rewardOption.rewardId === _this2.state.selectedRewardId;
        });
        this.props.setSelectedReward(selectedReward);
    },


    selectReward: function selectReward(reward) {
        var setStateCallback = function setStateCallback() {
            var chooseButton = document.querySelector('.choose-button');
            if (chooseButton) {
                chooseButton.focus();
            }
        };

        this.setState({ selectedRewardId: reward.rewardId }, setStateCallback);
    }
});

module.exports = ChangeNextRewardComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loyalty/chooseNextRewardComponent.js
// module id = 316
// module chunks = 0